module.exports = __webpack_public_path__ + "img/18-elaman-tuli.2b34be47.jpg";